<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('fleet.change_vehiclemodel') ||
      currentUser?.hasPermission('fleet.delete_vehiclemodel')
    "
  >
    <v-list-item
      v-if="currentUser.hasPermission('fleet.change_vehiclemodel')"
      @click="emit('vehicle-model-edit-pressed', vehicleModel)"
      title="Edit Vehicle Model"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-pencil" class="me-1" />
      </template>
    </v-list-item>

    <template v-if="currentUser.hasPermission('fleet.delete_vehiclemodel')">
      <v-divider class="pb-1" />
      <v-list-item
        class="text-error"
        @click="emit('vehicle-model-delete-pressed', vehicleModel)"
        title="Delete Vehicle Model"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-delete" class="me-1" />
        </template>
      </v-list-item>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import type { IVehicleModel } from '@/models/fleet-management'

import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  vehicleModel: IVehicleModel
}
defineProps<Props>()

interface Emit {
  (e: 'vehicle-model-edit-pressed', vehicle: IVehicleModel): void
  (e: 'vehicle-model-delete-pressed', vehicle: IVehicleModel): void
}

const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
